import React, { useState, useRef, useEffect } from "react";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import logo1 from "../../../../assets/images/idea.svg";
import logo2 from "../../../../assets/images/uiux.svg";
import logo3 from "../../../../assets/images/development.svg";
import logo4 from "../../../../assets/images/qa.svg";
import logo5 from "../../../../assets/images/deployment.svg";
import logo6 from "../../../../assets/images/support.svg";

function Innovation() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(null);

  useEffect(() => {
    const staticServices = [
      {
        title: "COLLECTION OF NEEDS",
        about: "Our process allows us to understand your needs and develop a strategic plan.",
        activeColor: "#6366f1",
        logo: logo1,
        link: "#",
      },
      {
        title: "UI/UX DESIGN",
        about: "UI/UX can significantly improve the quality and user satisfaction.",
        activeColor: "#f59e0b",
        logo: logo2,
        link: "#",
      },
      {
        title: "DEVELOPMENT",
        about: "Develop application and the services necessary for its proper functioning.",
        activeColor: "#f97316",
        logo: logo3,
        link: "#",
      },
      {
        title: "QUALITY ASSURANCE",
        about: "Our team ensures it performs as expected and is free of defects.",
        activeColor: "#10b981",
        logo: logo4,
        link: "#",
      },
      {
        title: "DEPLOYMENT",
        about: "We deploy the application on all stores like App Store and Play Store.",
        activeColor: "#84cc16",
        logo: logo5,
        link: "#",
      },
      {
        title: "SUPPORT AND EVOLUTION",
        about: "Our team is always ready to answer any questions after deployment.",
        activeColor: "#3b82f6",
        logo: logo6,
        link: "#",
      },
    ];

    setServices(staticServices);
    setLoading(false);
  }, []);

  const moveNext = () => sliderRef.current?.slickNext();
  const movePrev = () => sliderRef.current?.slickPrev();

  const settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "ease-in-out",
    centerMode: false,
    centerPadding: "0px",
    variableWidth: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (loading) return <div>Loading...</div>;

  return (
    <section className="relative py-20 overflow-hidden bg-gray-50">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-80 h-80 bg-blue-100 opacity-30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-100 opacity-30 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-green-100 opacity-20 rounded-full blur-3xl"></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6">
            Explore our services that
            <span className="text-blue-600"> bring ideas to life</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From concept to deployment, we provide comprehensive solutions that transform your vision into reality.
          </p>
        </div>

        {/* Navigation Controls */}
        <div className="flex justify-center">
          <div className="flex gap-4">
            <button
              className="w-14 h-14 bg-white border border-gray-200 rounded-2xl flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:border-gray-300 transition-all duration-300 shadow-sm hover:shadow-md"
              onClick={movePrev}
              aria-label="Previous slide"
            >
              <FaLongArrowAltLeft className="w-6 h-6" />
            </button>
            <button
              className="w-14 h-14 bg-white border border-gray-200 rounded-2xl flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:border-gray-300 transition-all duration-300 shadow-sm hover:shadow-md"
              onClick={moveNext}
              aria-label="Next slide"
            >
              <FaLongArrowAltRight className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Slider Container */}
        <div className="max-w-6xl mx-auto px-4 py-8">
          <Slider {...settings} ref={sliderRef}>
            {services.map((item, index) => (
              <div key={index} className="px-3">
                <ServiceCard
                  title={item.title}
                  logo={item.logo}
                  about={item.about}
                  link={item.link}
                  activeColor={item.activeColor}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

const ServiceCard = ({ link, title, about, activeColor, logo }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="bg-white border border-gray-200 rounded-2xl p-8 min-h-[100px] transition-all duration-300 hover:shadow-xl hover:border-gray-300 hover:-translate-y-1 cursor-pointer group relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Hover Effect Border */}
      <div 
        className="absolute inset-0 rounded-2xl transition-all duration-300 h-400"
        style={{
          background: isHovered ? `linear-gradient(135deg, ${activeColor}20, ${activeColor}10)` : 'transparent'
        }}
      />
      
      <div className="relative z-10 flex flex-col h-full">
        {/* Icon */}
        <div className="w-16 h-16 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 mb-6">
          <img src={logo} width={32} height={32} alt="service" />
        </div>
        
        {/* Content */}
        <div className="flex-1">
          <h4 className="text-xl font-bold text-gray-900 group-hover:text-gray-700 transition-colors duration-300">
            {title}
          </h4>
          <p className="text-gray-600 text-sm mt-2">
            {about}
          </p>
        </div>
        
        {/* Arrow Icon - Fixed at bottom */}
        {/* <div className="mt-auto">
          <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center group-hover:bg-gray-200 transition-colors duration-300">
            <svg className="w-4 h-4 text-gray-600 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Innovation;
